import { Serializer } from 'src/app/core/common/http/serializer';
import { AreaCoswinResource, OrderResource } from './area-coswin.resource';
import { AreaCoswinModel, OrderModel } from './area-coswin.model';

export class AreaCoswinSerializer implements Serializer { 
  fromJson(json: any): AreaCoswinResource { 
    const resource = new AreaCoswinResource();

    resource.commesse = json.commesse;
    resource.site = json.site;
    resource.job = json.job;
    resource.app_on_phone = json.app_on_phone;
    resource.type_user = json.type_user;
    resource.notes = json.notes;
    resource.cid = json.cid;
    resource.phone = json.phone;
    
    return resource;
  }

  toJson(model: AreaCoswinModel): any  {
    const resource = new AreaCoswinResource();

    model.commesse.forEach((commessa)=>{
      resource.commesse.push(commessa.project_name)
    });
    resource.site = model.site;
    resource.job = model.job[0].description;
    resource.app_on_phone = model.app_on_phone;
    resource.type_user = model.type_user[0].description;
    resource.notes = model.notes;
    resource.cid = model.cid;
    resource.phone = model.phone;
    
    return resource;
  }
}

export class OrderSerializer implements Serializer {
  fromJson(json: any): OrderModel {
    
    const model = new OrderModel();
    // model.id = json.udb_code + '-' + json.area_code + '-' + json.cdc_code + '- ' + json.segment_code;
    model.id = json.segment_code;
    model.project_name = json.project_name;
    model.cdc_type = json.cdc_type;
    model.project_description = json.project_description;

    return model;
  }

  toJson(model: OrderModel): any  {
    const commessaResource = new OrderResource();
    // const arr = model.id.split('-');

    // commessaResource.udb_code = arr[0];
    // commessaResource.area_code = arr[1];
    // if(arr[2] != "undefined") commessaResource.cdc_code = arr[2];
    // else commessaResource.cdc_code = model.cdc_type

    commessaResource.segment_code = model.id; // arr[3];
    commessaResource.active = model.active;
    commessaResource.project_name = model.project_name;
    commessaResource.project_description = model.project_description;
    
    return commessaResource;
  }
}
